<script setup lang="ts">
  import { TooltipTrigger, type TooltipTriggerProps } from "reka-ui"
  import Icon from "@/components/ui/icons/Icon.vue"

  const props = defineProps<TooltipTriggerProps>()
</script>

<template>
  <TooltipTrigger
    v-bind="props"
    data-testid="plain-tooltip-trigger"
    class="focus:outline-primary-400"
  >
    <slot>
      <Icon name="Info" data-testid="plain-tooltip-trigger-icon" size="lg" />
    </slot>
  </TooltipTrigger>
</template>
